import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IEdge, ILeaseSearchResult } from '@api'

export interface IPayload {
  data: {
    viewer: {
      company: {
        contracts: {
          edges: IEdge<ILeaseSearchResult>[]
        }
      }
    }
  }
}

export default function search(query: string): Promise<ILeaseSearchResult[]> {
  const variables = { query }
  return client.gql.query({ query: searchLeasesQuery, variables }).then(
    ({
      data: {
        viewer: {
          company: {
            contracts: { edges },
          },
        },
      },
    }: IPayload) => edges.map(({ node }) => node)
  )
}

const searchLeasesQuery = gql`
  query LeaseSearch($query: String) {
    viewer {
      company {
        contracts(first: 7, query: $query, type: Lease) {
          edges {
            node {
              id
              endDate
              title
              floor {
                name
                building {
                  address
                  name
                  city
                }
              }
              building {
                address
                name
                city
              }
            }
          }
        }
      }
    }
  }
`
